import {Component, Output, EventEmitter, OnInit, Input, OnDestroy, HostListener, ElementRef} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { AuthenticationService, LocalStorageService, EventService, GameGroupService } from '../../services';
import {TranslateService} from '@ngx-translate/core';
import {CookieService} from 'ngx-cookie-service';
import {fromEvent} from 'rxjs/observable/fromEvent';
import {map} from 'rxjs/operators';
import {Subscription} from 'rxjs/Subscription';


declare var jQuery: any;

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.css'],
  moduleId: module.id
})

export class HeaderComponent implements OnInit, OnDestroy {

  public loginForm: FormGroup;
  public userLoginStatus: boolean = false;
  public gameGroups: Array<object> = [];
  public menuShown:Boolean = false;
  @Input() public user = null;
  @Input() public isUserAuthenticated: boolean = false;
  @Input() public menuOverlayShown:Boolean = false;
  @Output() private onLogin = new EventEmitter();
  @Output() private onLogout = new EventEmitter();
  @Output() private onMenuToggle = new EventEmitter();
  public isLanguageMenuShow = false;
  public isMobileLanguageMenuShow = false;
  public selectedLang: any;
  public bodyClickSubs: Subscription;
  public langSelectionSubs: Subscription;
  /*public langs = [
    {label: 'English', value: 'EN'},
    {label: 'Turkish', value: 'TR'},
    {label: 'Italian', value: 'ITA'},
    {label: 'Spanish', value: 'SPA'},
    {label: 'German', value: 'GER'},
    {label: 'Chinese', value: 'CHI'},
    {label: 'French', value: 'FRE'},
  ];*/


  constructor(
    private authenticationService: AuthenticationService,
    private localStorageService: LocalStorageService,
    private eventService: EventService,
    private formBuilder: FormBuilder,
    private gameGroupService: GameGroupService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private el: ElementRef
  ) {
      this.translate.addLangs(['english', 'turkish', 'spanish']);
      this.translate.setDefaultLang('english');

    const checkLang = this.cookieService.check('lang');
    if (checkLang) {
      this.selectedLang = this.cookieService.get('lang').toLowerCase();
    } else {
      this.selectedLang = 'english';
      this.cookieService.set('lang', this.selectedLang);
    }
    this.translate.use(this.selectedLang);
  }

  ngOnInit(): any {
    this.loginForm = this.formBuilder.group({
      identity: ['', Validators.required],
      password: ['', Validators.required]
    });
    this.eventService.getAuthenticationStatus()
      .subscribe(data => {
        this.userLoginStatus = data.status;
      });
    this.gameGroupService.getCurrentGameGroups()
      .subscribe(gameGroups => {
        this.gameGroups = gameGroups;
      });
    const bodyClickEvent = this.startClickListener(document);
    this.bodyClickSubs = bodyClickEvent.subscribe(val => {
      if (this.isLanguageMenuShow === true) {
        this.isLanguageMenuShow = false;
      }
      if (this.isMobileLanguageMenuShow) {
        this.isMobileLanguageMenuShow = false;
      }
    });
    this.langStopPropagation('language-div');
    this.langStopPropagation('language-div-mobile');
  }

  mobileLanguageEvent() {
    this.isMobileLanguageMenuShow = !this.isMobileLanguageMenuShow;
  }

  closeModal() {
    jQuery('#modal-login-register').modal('toggle');
  }

  getSelectedLang(lang) {
    this.selectedLang = lang;
    this.changeLocalLanguage(lang);
  }

  langStopPropagation(el_id) {
    const langSelectionEvent = this.startClickListener(document.getElementById(el_id));
    this.langSelectionSubs = langSelectionEvent.subscribe((val: any ) => {
      val.stopPropagation();
    });
  }

  changeLocalLanguage(lang) {
    this.translate.use(lang);
    /*if (this.cookieService.get('lang') !== lang) {
      window.location.reload();
    }*/
    this.cookieService.set('lang', lang);
  }

  startClickListener(element) {
    const source = fromEvent(element, 'click');
    return source.pipe(map(event => {
      return event;
    }));
  }

  openLanguage() {
    this.isLanguageMenuShow = !this.isLanguageMenuShow;
  }

  login() {
    let values = {
      identity: this.loginForm.value.identity,
      password: this.loginForm.value.password
    };
    this.onLogin.emit(values);
  }

  logout() {
    this.onLogout.emit();
  }

  toggleMenu() {
    this.menuOverlayShown = !this.menuOverlayShown;
    this.onMenuToggle.emit(this.menuOverlayShown);
  }
  ngOnDestroy() {
    this.langSelectionSubs.unsubscribe();
    this.bodyClickSubs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/components/header/header.component.ts